import Vue from 'vue';
import VueMeta from 'vue-meta';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import PortalVue from 'portal-vue';
import VueCompositionAPI from '@vue/composition-api';
import { clearGlobalStream } from '@huntica/huntica-interview-module/src/mediaHelpers';
import VueGtag from 'vue-gtag';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import createRouter from './router/router';
import store from './store/store';
import i18n from './i18n';
import vuetify from './plugins/vuetify';

Vue.use(PortalVue);
Vue.use(VueMeta);
Vue.use(VueCompositionAPI);
Vue.component('VuePhoneNumberInput', VuePhoneNumberInput);

if (process.browser) {
// eslint-disable-next-line global-require
  const VueGoogleMaps = require('vue2-google-maps');
  Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
      language: i18n.locale,
    },
    installComponents: true,
  });
  Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
    loaderOptions: {
      autoHideBadge: true,
    },
  });
}

Vue.config.devtools = process.env.VUE_DEV_TOOLS === 'true' || process.env.NODE_ENV === 'development';

export default () => {
  const router = createRouter(store);

  // https://accordev.atlassian.net/browse/HUN-1281
  router.onError((error) => {
    if (/loading chunk \d* failed./i.test(error.message) && window) {
      window.location.reload();
    }
  });

  function clearStream(to) {
    const routes = [
      'interview',
      'interview_test',
      'interviewContinue',
      'interviewTestContinue',
      'interviewIframe',
      'iframeInterviewContinue',
      'iframeInterviewTestContinue',
    ];
    if (!routes.includes(to.name)) {
      clearGlobalStream();
    }
  }

  Vue.use(VueGtag, {
    config: {
      id: 'G-3HZDB0CRVH',
    },
  }, router);

  router.afterEach(clearStream);

  const app = new Vue({
    silent: process.env.NODE_ENV === 'production',
    productionTip: process.env.NODE_ENV !== 'production',
    vuetify,
    router,
    store,
    i18n,
    // eslint-disable-next-line global-require
    render: h => h(require('./App.vue').default),
  });

  return { app, router, store };
};
